<app-spinner-overlay
    [showSpinner]="viewModel.isEditingBooking"
>
</app-spinner-overlay>
<div class="booking-details-panel vstack gap-3">
    <app-requested-booking-details
        *ngIf="viewModel.canAcceptBooking"
        [booking]="booking"
    >
    </app-requested-booking-details>
    <div
        class="booking-details-card vstack gap-2 gap-lg-3"
    >
        <div
            *ngIf="viewModel.bookingName as bookingName"
            class="booking-details__customer-row row align-items-baseline"
        >
            <span
                class="col-md-3 py-2"
            >
                Booked by
            </span>
            <div
                class="col-md-9"
            >
                <div class="vstack gap-2">
                    <div class="hstack gap-2">
                        <button
                            class="btn btn-outline-secondary hstack gap-1"
                            [ngClass]="{
                                'disabled': !viewModel.canGoToCustomer
                            }"
                            (click)="viewModel.goToCustomer()"
                        >
                            {{ viewModel.bookingName }}
                            <img
                                ngSrc="assets/right/normal.svg"
                                alt="Go to Customer"
                                width="16"
                                height="16"
                            />
                        </button>
                        @if (viewModel.showVip) {
                            <img
                                ngSrc="assets/vip/normal_dark.svg"
                                width="16"
                                height="16"
                                [ngbTooltip]="'VIP Customer'"
                            />
                        }
                    </div>
                    @if (booking.customer?.note(); as note) {
                        <div class="hstack gap-2">
                            <img
                                ngSrc="assets/person/normal.svg"
                                alt="Customer Note"
                                width="18"
                                height="18"
                            />
                            @let limit = 60;
                            <span
                                [ngbTooltip]="note"
                                [disableTooltip]="note.length <= limit"
                                [container]="'body'"
                            >
                                {{ note | slice : 0 : limit }}@if (note.length > limit) {...}
                                
                            </span>
                        </div>
                    }
                    @let foodDrinkPreferences = booking.customer?.foodDrinkPreferences;
                    @if (foodDrinkPreferences) {
                        <div class="hstack gap-2">
                            <img
                                ngSrc="assets/food-drink/normal.svg"
                                alt="Food & Drink Preferences"
                                width="18"
                                height="18"
                            />
                            @let limit = 60;
                            <span
                                [ngbTooltip]="foodDrinkPreferences"
                                [disableTooltip]="foodDrinkPreferences.length <= limit"
                            >
                                {{ foodDrinkPreferences | slice : 0 : limit }}@if (foodDrinkPreferences.length > limit) {...}
                            </span>
                        </div>
                    }
                </div>
            </div>
        </div>
        <hr class="booking-details__customer-row m-0"/>
        <div
            class="row align-items-baseline"
        >
            <span
                class="col-md-3 py-2"
            >
                Date
            </span>
            <div class="col-md-9">
                <button
                    class="btn btn-outline-secondary"
                    data-testid="booking-start-date"
                    (click)="showChangeBookingStartTimeOptions()"
                >
                    {{ booking.start | dateTime : venue.timeZone : undefined : "EEE, MMM d" }}
                </button>
            </div>
        </div>
        <div
            class="row align-items-baseline"
        >
            <span
                class="col-md-3 py-2"
            >
                Time
            </span>
            <div class="col-md-9 vstack gap-2">
                <div class="hstack center gap-2">
                    <button
                        class="btn btn-outline-secondary"
                        data-testid="booking-start-time"
                        (click)="showChangeBookingStartTimeOptions()"
                    >
                        {{ booking.start | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }}
                    </button>
                    <span>
                        –
                    </span>
                    <app-element-choice-select
                        #changeEndTime
                        [startingSelection]="bookingTimeViewStartingSelection"
                        [canChangeElement]="true"
                        [dataTestId]="'booking-end-time'"
                        (loadElements)="viewModel.showChangeBookingTimeOptions()"
                        (elementChosen)="viewModel.updateBookingTime($event)"
                        class="booking-details__end-time"
                    >
                    </app-element-choice-select>
                </div>
                @if (area) {
                    @if (tableTurnaroundInterval > 0) {
                        <span data-testid="table-turnaround-prompt">
                            Turn around table at {{ booking.occupiedEndDate(tableTurnaroundInterval) | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }}
                        </span>
                    }
                }
            </div>
        </div>
        <div
            class="row align-items-baseline"
        >
            <span
                class="col-md-3 py-2"
            >
                Party Size
            </span>
            <div
                class="col-md-9"
            >
                <app-element-choice-select
                    #changePartySize
                    data-testid="booking-party-size"
                    [canChangeElement]="true"
                    [startingSelection]="partySizeStartingSelection"
                    [warningText]="'This party size may not fit the selected tables'"
                    [warningValues]="viewModel.selectedTablesPartySizeOptions"
                    [warningTestId]="'booking-party-size-warning'"
                    (loadElements)="showChangePartySizeOptions()"
                    (elementChosen)="viewModel.updatePartySize($event)"
            >
                </app-element-choice-select>
            </div>
        </div>
        <div
            class="row align-items-baseline"
            [class.d-none]="viewModel.bookingReason === null && viewModel.reasonsReservableOnBookingDate.length === 0"
        >
            <span
                class="col-md-3 py-2"
            >
                Reason
            </span>
            <div
                class="col-md-9"
            >
                <div class="booking-details__reason hstack gap-2 flex-nowrap">
                    @if (viewModel.bookingReasonCalendarColour; as calendarColour) {
                        <span
                            class="booking-details__reason-colour-swatch flex-shrink-0"
                            data-testid="booking-reason-calendar-colour"
                            [style.background-color]="calendarColour"
                            aria-hidden="true"
                        ></span>
                    }
                    <app-element-choice-select
                        #changeBookingReason
                        [startingSelection]="bookingReasonStartingSelection"
                        [canChangeElement]="true"
                        [dataTestId]="'booking-reason'"
                        (loadElements)="viewModel.showChangeBookingReasonOptions()"
                        (elementChosen)="viewModel.updateBookingReason($event)"
                        class="flex-grow-1 min-w-0"
                    >
                    </app-element-choice-select>
                </div>
            </div>
        </div>
        <div
            class="row align-items-baseline"
            [class.d-none]="viewModel.eventsReservableOnBookingDate.length === 0"
        >
            <span
                class="col-md-3 py-2"
            >
                Event
            </span>
            <div
                class="col-md-9"
            >
                <app-element-choice-select
                    #changeBookingEvent
                    [startingSelection]="bookingEventStartingSelection"
                    [canChangeElement]="true"
                    [dataTestId]="'booking-event'"
                    (loadElements)="viewModel.showChangeBookingEventOptions()"
                    (elementChosen)="viewModel.updateBookingEvent($event)"
                    class="flex-grow-1"
                >
                </app-element-choice-select>
            </div>
        </div>
        <div
            class="row align-items-baseline"
        >
            <div class="py-2 col-md-3 hstack align-items-start gap-2">
                Customer Request
            </div>
            <div
                class="col-md-9 hstack gap-2 align-items-start"
            >
                <app-textarea
                    #customerMessage
                    [style.display]="'contents'"
                    [placeholder]="'Add Customer Request'"
                    [isEditable]="true"
                    [initialValue]="booking.notes"
                    [rows]="3"
                    buttonClasses="btn-plain py-1 fst-italic"
                    [quoteValue]="true"
                    (textSubmitted)="viewModel.updateCustomerMessage($event)">
                </app-textarea>
            </div>
        </div>
        <hr class="m-0"/>
        @if (area) {
            <div
                class="row align-items-baseline"
            >
                <span
                    class="col-md-3 py-2"
                >
                    Area
                </span>
                <div
                    class="col-md-9"
                >
                    <button
                        class="btn btn-outline-secondary disabled me-auto"
                        data-testid="booking-area"
                    >
                        {{ area.displayName }}
                    </button>
                </div>
            </div>
        }
        <div
            class="row align-items-baseline"
        >
            <span
                class="col-md-3 py-2"
            >
                Table
            </span>
            <div class="col-md-9 hstack center gap-2">
                <button
                    class="btn btn-outline-secondary editable"
                    data-testid="booking-table"
                    [disabled]="booking.lockedToTables"
                    [ngbTooltip]="booking.lockedToTables ? 'Locked to ' + (booking | tableName : area) : undefined"
                    (click)="showChangeBookingTableOptions()"
                >
                    {{ booking | tableName: area }}
                </button>
                @if (booking.lockedToTables) {
                    <button
                        class="btn btn-outline-secondary"
                        (click)="toggleBookingLockedToTables()"
                        [ngbTooltip]="'Unlock from ' + (booking | tableName : area)"
                    >
                        <img
                            ngSrc="assets/locked/normal.svg"
                            alt="Lock to Tables"
                            width="24"
                            height="24"
                        />
                    </button>
                } @else {
                    <button
                        class="btn btn-outline-secondary"
                        (click)="toggleBookingLockedToTables()"
                        [ngbTooltip]="'Lock to ' + (booking | tableName : area)"
                    >
                        <img
                            ngSrc="assets/unlocked/normal.svg"
                            alt="Unlock from Tables"
                            width="24"
                            height="24"
                        />
                    </button>
                }
            </div>
        </div>
    </div>
    <div
        class="booking-details-card vstack gap-2 gap-lg-3"
    >
        <div
            *ngIf="viewModel.showAccessibilitySection"
            class="row align-items-baseline"
        >
            <span
                class="col-md-3 py-2"
            >
                Accessibility
            </span>
            <div class="col-md-9 hstack gap-2">
                <label
                    *ngIf="viewModel.showDogFriendlyOption"
                    class="btn btn-outline-secondary d-flex align-items-center gap-2"
                    data-testid="requires-dog-friendly"
                >
                    <input
                        type="checkbox"
                        class="form-check-input m-0"
                        [checked]="viewModel.requiresDogFriendly"
                        (change)="viewModel.toggleRequiresDogFriendly()"
                    >
                    <span>Dog Friendly</span>
                </label>
                <label
                    *ngIf="viewModel.showWheelchairAccessOption"
                    class="btn btn-outline-secondary d-flex align-items-center gap-2"
                    data-testid="requires-wheelchair-access"
                >
                    <input
                        type="checkbox"
                        class="form-check-input m-0"
                        [checked]="viewModel.requiresWheelchairAccess"
                        (change)="viewModel.toggleRequiresWheelchairAccess()"
                    >
                    <span>Wheelchair Access</span>
                </label>
                <label
                    *ngIf="viewModel.showPramAccessibleOption"
                    class="btn btn-outline-secondary d-flex align-items-center gap-2"
                    data-testid="requires-pram-accessible"
                >
                    <input
                        type="checkbox"
                        class="form-check-input m-0"
                        [checked]="viewModel.requiresPramAccessible"
                        (change)="viewModel.toggleRequiresPramAccessible()"
                    >
                    <span>Pram Accessible</span>
                </label>
                <label
                    *ngIf="viewModel.showHighchairFriendlyOption"
                    class="btn btn-outline-secondary d-flex align-items-center gap-2"
                    data-testid="requires-highchair-friendly"
                >
                    <input
                        type="checkbox"
                        class="form-check-input m-0"
                        [checked]="viewModel.requiresHighchairFriendly"
                        (change)="viewModel.toggleRequiresHighchairFriendly()"
                    >
                    <span>Highchair Friendly</span>
                </label>
            </div>
        </div>
        <hr class="m-0"/>
        <div
            class="row align-items-baseline"
        >
            <div class="py-2 col-md-3 hstack align-items-start gap-2">
                Private Booking Notes
            </div>
            <div
                class="col-md-9 hstack gap-2 align-items-start"
            >
                <button
                    *ngIf="viewModel.showHidePrivateNotesButton"
                    class="btn btn-outline-secondary"
                    (click)="viewModel.togglePrivateNotesVisibility()"
                >
                    <img
                        ngSrc="../../../../../assets/visible/normal.svg"
                        width="24"
                        height="24"
                        alt="Hide Private Notes"
                    >
                </button>
                <button
                    *ngIf="viewModel.showShowPrivateNotesButton"
                    class="btn btn-outline-secondary"
                    (click)="viewModel.togglePrivateNotesVisibility()"
                >
                    <img
                        ngSrc="../../../../../assets/hidden/normal.svg"
                        width="24"
                        height="24"
                        alt="Show Private Notes"
                    >
                </button>
                <app-textarea
                    #merchantNotes
                    [style.display]="'contents'"
                    [isEditable]="!viewModel.hidePrivateNotes"
                    [redacted]="viewModel.hidePrivateNotes"
                    [placeholder]="'Add Private Booking Notes'"
                    [initialValue]="booking.merchantNotes"
                    [rows]="3"
                    (textSubmitted)="viewModel.updateMerchantNotes($event)">
                </app-textarea>
            </div>
        </div>
    </div>
    @if (viewModel.checkboxQuestions.length || viewModel.textQuestions.length || viewModel.multipleChoiceQuestions.length) {
        <div
            class="booking-details-card vstack gap-4"
        >
            <div
                *ngFor="let question of viewModel.checkboxQuestions"
                class="hstack gap-4"
            >
                <div class="fw-semibold">
                    {{ question.question }}
                </div>
                <button
                    class="btn btn-outline-secondary disabled me-auto"
                >
                    <span
                        *ngIf="question.ticked"
                    >
                        Yes
                    </span>
                    <span
                        *ngIf="!question.ticked"
                    >
                        No
                    </span>
                </button>
            </div>
            <div
                *ngFor="let question of viewModel.textQuestions"
                class="hstack gap-4"
            >
                <div class="fw-semibold">
                    {{ question.question }}
                </div>
                <app-input
                    #textQuestionInput
                    [isEditable]="question.isEditable"
                    [placeholder]="'Enter answer'"
                    [readonlyValue]="question.answer"
                    [initialValue]="question.answer"
                    [inputType]="InputType.Text"
                    [attr.data-testid]="'text-question-' + question.index"
                    (inputSubmitted)="viewModel.updateTextQuestionAnswer(question.questionId, $event)"
                >
                </app-input>
            </div>
            <div
                *ngFor="let question of viewModel.multipleChoiceQuestions"
                class="hstack gap-4"
            >
                <div class="hstack gap-2 fw-semibold">
                    {{ question.question }}
                    @if (question.icon) {
                        <img
                            [src]="question.icon"
                            alt=""
                            width="20"
                            height="20"
                        >
                    }
                </div>
                <div class="hstack gap-2">
                    <button
                        *ngFor="let option of question.options"
                        class="btn btn-outline-secondary disabled"
                        [attr.data-testid]="'question-option-' + option"
                    >
                        {{ option }}
                    </button>
                </div>
            </div>
        </div>
    }
    <div
        class="booking-details-card vstack gap-2 gap-lg-3"
    >
        <div
            class="row align-items-baseline"
        >
            <span
                class="col-md-3 py-2"
            >
                Marketing Opt-In
            </span>
            <div
                class="col-md-9"
            >
                <button
                    class="btn btn-outline-secondary disabled me-auto"
                >
                    {{ booking.agreedToMarketing ? 'Yes' : 'No' }}
                </button>
            </div>
        </div>
        @if (venue.isSendFeedbackRequestEnabled()) {
            <div
                class="row align-items-baseline"
            >
                <span
                    class="col-md-3 py-2"
                >
                    Send Booking Feedback Request
                </span>
                <div
                    class="col-md-9 vstack gap-1"
                >
                    <div class="form-check form-switch hstack gap-2 align-items-center">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="booking-send-feedback-request"
                            [checked]="booking.sendFeedbackRequest"
                            (change)="updateSendFeedbackRequest(!booking.sendFeedbackRequest)"
                        >
                        <label
                            class="form-check-label"
                            for="booking-send-feedback-request"
                        >
                            {{ booking.sendFeedbackRequest ? 'Enabled' : 'Disabled' }}
                        </label>
                    </div>
                    <span class="form-text">
                        Send a feedback request to the customer after the booking has been finished.
                    </span>
                </div>
            </div>
        }
    </div>
</div>
